import React from 'react'
import styles from '../../assets/styles/styles.module.css'
import clsx from 'clsx'
import { RatingContext } from '../../utils/RatingContext'
import { RatingIcon } from '../Stars/RatingIcon'
import { isValidRating } from '../../utils/ratingValidation'

export const StarRating = (): React.ReactElement => {
  const setGuidedToggle = React.useContext(RatingContext).setGuidedToggle
  const rating = React.useContext(RatingContext).rating
  const setRating = React.useContext(RatingContext).setRating
  const formError = React.useContext(RatingContext).formError
  const setFormError = React.useContext(RatingContext).setFormError
  const [hoverRating, setHoverRating] = React.useState(0)
  const Ratings = [1, 2, 3, 4, 5];

  const onMouseEnter = (index: number) => {
    setHoverRating(index)
  }
  const onMouseLeave = () => {
    setHoverRating(0)
  }
  const onSaveRating = (index: number) => {
    setRate(index)
  }

  const setRate = (ratingValue: number) => {
    if (!isValidRating(ratingValue)) {
      return
    }
    setRating(ratingValue)
    if (formError) {
        setFormError(false)
    }
    setGuidedToggle(true)
}

  return (
    <div className={clsx(styles.flexContainer)}>
      {Ratings.map((rate: number) => (
        <RatingIcon
          key={rate}
          index={rate}
          rating={rating}
          hoverRating={hoverRating}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          onSaveRating={onSaveRating} />
      ))}
    </div>
  )
}
